import Loading from '../../../Common/Loading';
import { usePhonesChartsDataContext } from './hooks/usePhonesChartsDataContext';
import { BrandAnualList } from './BrandAnualList';
import { BrandMonthList } from './BrandMonthList';
import { TypeAnualList } from './TypeAnualList';
import { TypeMonthList } from './TypeMonthList';
import { SubtypeAnualList } from './SubtypeAnualList';
import { SubtypeMonthList} from './SubtypeMonthList'
import { BlockStatusAnualList } from './BlockStatusAnualList';
import { BlockStatusMonthList } from './BlockStatusMonthList';
import { QuantityAnualList } from './QuantityAnualList';
import { QuantityMonthList} from './QuantityMonthList'

export const Charts = () => {
    const { isLoading } = usePhonesChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <div className="charts-side-by-side-dashboards">
                <BrandAnualList />
                <BrandMonthList />
            </div>
            <div className="charts-side-by-side-dashboards">    
                <TypeAnualList />
                <TypeMonthList />
            </div>
            <div className="charts-side-by-side-dashboards">    
                <SubtypeAnualList />
                <SubtypeMonthList />
            </div>
            <div className="charts-side-by-side-dashboards">    
                <BlockStatusAnualList />
                <BlockStatusMonthList />
            </div>
            <div className="charts-side-by-side-dashboards">    
                <QuantityAnualList />
                <QuantityMonthList />
            </div>
        </>
    );
};
